import React from 'react';
import { BoardToolboxToolButton } from './boardToolboxActionButton';

export const BoardToolboxToolList = ({
  activeTool = 'select',
  onToolChange,
  tools = [],
  inactiveTool = 'select',
}) => (
  <>
    {tools.map(toolConfig => (
      <BoardToolboxToolButton
        key={toolConfig.tool}
        title={toolConfig.title}
        tool={toolConfig.tool}
        activeTool={activeTool}
        onToolChange={onToolChange}
        onContextMenu={toolConfig.onContextMenu}
        inactiveTool={inactiveTool}
      >
        {toolConfig.icon}
      </BoardToolboxToolButton>
    ))}
  </>
);
